import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChartjsModule } from '@ctrl/ngx-chartjs';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@shared/material/material.module';
import { DynamicFormsModule } from '@shared/modules/dynamic-forms/dynamic-forms.module';
import { TablesModule } from '@shared/modules/tables/tables.module';
import { AsyncSelectorComponent } from './components/async-selector/async-selector.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { CommonEditorComponent } from './components/dialogs/common-editor/common-editor.component';
import { ConfirmComponent } from './components/dialogs/confirm/confirm.component';
import { DiskSizeSliderComponent } from './components/disk-size-slider/disk-size-slider.component';
import { HeadsetComponent } from './components/headset/headset.component';
import { ImagesSelectorComponent } from './components/images-selector/images-selector.component';
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component';
import { LoaderComponent } from './components/loader/loader.component';
import { NoVncComponent } from './components/no-vnc/no-vnc.component';
import { PagedCardsComponent } from './components/paged-cards/paged-cards.component';
import { PaymentBtnComponent } from './components/payment-btn/payment-btn.component';
import { PaymentDialogComponent } from './components/payment-dialog/payment-dialog.component';
import { RouterTabsComponent } from './components/router-tabs/router-tabs.component';
import { TarifSelectorComponent } from './components/tarif-selector/tarif-selector.component';
import { WsXtermComponent } from './components/ws-xterm/ws-xterm.component';
import { MemoryPipe } from './pipes/memory.pipe';
import { ReplacePipe } from './pipes/replace.pipe';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DynamicFormsModule,
    TranslateModule,
    ChartjsModule,
    RouterModule,
    TranslateModule,
    TablesModule,
    ReactiveFormsModule
  ],
  declarations: [
    ConfirmComponent,
    PagedCardsComponent,
    CommonEditorComponent,
    ReplacePipe,
    LanguageSwitcherComponent,
    ImagesSelectorComponent,
    TarifSelectorComponent,
    MemoryPipe,
    WsXtermComponent,
    HeadsetComponent,
    BreadcrumbsComponent,
    RouterTabsComponent,
    AsyncSelectorComponent,
    LoaderComponent,
    NoVncComponent,
    PaymentDialogComponent,
    PaymentBtnComponent,
    DiskSizeSliderComponent,
  ],
  exports: [
    PagedCardsComponent,
    DynamicFormsModule,
    ReplacePipe,
    LanguageSwitcherComponent,
    ImagesSelectorComponent,
    TarifSelectorComponent,
    WsXtermComponent,
    MemoryPipe,
    HeadsetComponent,
    RouterTabsComponent,
    TablesModule,
    AsyncSelectorComponent,
    LoaderComponent,
    NoVncComponent,
    PaymentBtnComponent,
    DiskSizeSliderComponent
  ],
  entryComponents: [
    ConfirmComponent,
    CommonEditorComponent,
    PaymentDialogComponent
  ]
})
export class SharedModule {
}
